import * as tools from '../Tools';

export default class Quickfind {
    constructor() {
        $.widget('custom.catcomplete', $.ui.autocomplete, {
            _create: function () {
                this._super();
                this.widget().menu('option', 'items', '> :not(.ui-autocomplete-category)');
            },
            _renderMenu: function (ul, items) {
                var that = this,
                    currentCategory = '';
                $.each(items, function (index, item) {
                    var li;
                    if (item.category !== currentCategory) {
                        ul.append("<li class='ui-autocomplete-category'>" + item.category + '</li>');
                        currentCategory = item.category;
                    }
                    li = that._renderItemData(ul, item);
                    if (item.category) {
                        li.attr('aria-label', item.category + ' : ' + item.label);
                    }
                });
            }
        });
        this.QuickFind();
    }

    private async QuickFind() {
        /**
         * window.quickfind: wird in cms.js genutzt
         */
        window.quickfind = await tools.fetchJSON('/Handler/Quickfind');
        window.quickfind = (<Array<any>>window.quickfind).sort(
            (itemA,itemB) => itemA.category < itemB.category ? -1 : 1
        );

        $('#qfind').catcomplete({
            delay: 0,
            source: window.quickfind,
            select: function (event, ui) {
                location.href = ui.item.path;
            }
        });
        let stationFind = (<Array<any>>window.quickfind).filter(
            item => item.category !== '' && item.category !== '-'
        );
        $('.bar.search-bar input').catcomplete({
            delay: 0,
            source: stationFind,
            select: function (event, ui) {
                location.href = ui.item.path;
            }
        });

    }
}
